<main class="dialog-container">
  <section class="dialog-header">
    <h2 mat-dialog-title>{{ data.dialogHeader }}</h2>
    <mat-icon matDialogClose class="exit-button">clear</mat-icon>
  </section>
  <mat-dialog-content class="dialog-content">
    @if (!data.dialogHeader.includes(questionnaireTitle)) {
      <p>{{ data.dialogContent }}</p>
    }
    @if (data.dialogHeader == contractDialogTitle) {
      <section>
        <app-upload-files
          fieldLabel="contract"
          (fileEmitter)="setFile($event)"
        />
      </section>
    }
    @if (data.dialogHeader.includes(questionnaireTitle)) {
      <section>
        @if (data.dialogContent.length === 0) {
          <p class="response-warning">No questionnaire responses found.</p>
        }
        @for (response of data.dialogContent; track response) {
          <section class="responses-questions">
            <p class="question">{{ response.question }}</p>
            <p class="response">{{ response.response }}</p>
          </section>
        }
      </section>
    }
    @if (data.dialogHeader.includes(revertApplicationTitle)) {
      <section>
        <form [formGroup]="form" (ngSubmit)="OnSubmit()">
          <mat-radio-group
            formControlName="status"
            aria-labelledby="example-radio-group-label"
            class="radio-group"
            color="primary"
          >
            @for (option of revertOptions; track option) {
              <mat-radio-button class="radio-button" [value]="option">
                {{ option }}
              </mat-radio-button>
            }
          </mat-radio-group>
          @if (
            form.get("status")?.hasError("required") &&
            form.get("status")?.touched
          ) {
            <mat-error class="matError">
              {{ revertStage }}
            </mat-error>
          }
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            class="reason-input-field"
          >
            <mat-label>Input reason</mat-label>
            <input matInput formControlName="revertReason" />
          </mat-form-field>
          @if (
            form.get("revertReason")?.hasError("required") &&
            form.get("revertReason")?.touched
          ) {
            <mat-error class="matError">
              {{ revertReason }}
            </mat-error>
          }
        </form>
      </section>
    }
  </mat-dialog-content>
  @if (!data.dialogHeader.includes(questionnaireTitle)) {
    <mat-dialog-actions class="dialog-actions">
      <button mat-button color="accent" (click)="onCancel()">
        {{ data.cancelButtonLabel ? data.cancelButtonLabel : cancelButton }}
      </button>
      <section>
        @if (data.dialogHeader == contractDialogTitle) {
          <button mat-raised-button color="accent" (click)="contractFailed()">
            Contract failed
          </button>
        }
        <button
          mat-raised-button
          color="primary"
          (click)="OnSubmit()"
          [disabled]="
            (!contractFileUploaded &&
              data.dialogHeader == contractDialogTitle) ||
            (form.invalid && data.dialogHeader.includes(revertApplicationTitle))
          "
        >
          {{
            data.confirmButtonLabel ? data.confirmButtonLabel : confirmButton
          }}
        </button>
      </section>
    </mat-dialog-actions>
  }
</main>
